<template>
    <div>
        <h4>index page</h4>
    </div>
</template>

<script>
    module.exports = {
        components: {
        },

        data: function() {
            return {
                code: '<div>123</div>'
            }
        }
    };
</script>


/** WEBPACK FOOTER **
 ** index.vue?60695ba8
 **/